import { render, staticRenderFns } from "./Abstract.vue?vue&type=template&id=513ebbea&scoped=true"
import script from "./Abstract.vue?vue&type=script&lang=js"
export * from "./Abstract.vue?vue&type=script&lang=js"
import style0 from "./Abstract.vue?vue&type=style&index=0&id=513ebbea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ebbea",
  null
  
)

export default component.exports